import "./CustomClinikitButtonLight.css";

function CustomClinikitButtonLight({
  children,
  size = "medium",
  fullWidth = false,
  onClick,
  type = "button",
  disabled = false,
  className = "",
}) {
  const classNames = [
    "btn-light",
    `btn-light-${size}`,
    fullWidth ? "btn-light-full-width" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type={type}
      className={classNames}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

export default CustomClinikitButtonLight;
